// extracted by mini-css-extract-plugin
export default {"container":"nHnQi","support":"kq4Il","footer":"LuFUb"};